import { ApiResponse } from '@ustra/data/src/models/api-model'
import { HttpMethod } from '@ustra/core/src/server/http/const'
import { UtraService } from '@ustra/nuxt/src/services/ustra-service'
import { GetPushNotification, SetPushNotification } from '~/model/co/push-noti-model'

/**
 * 푸시 설정 정보
 *
 * @export
 * @class PushService
 * @extends {UtraService}
 */
export class PushService extends UtraService {
  async getPushAdmin() {
    const result = await this.$ustra.api.call<ApiResponse<GetPushNotification>>({
      url: '/api/cm/push/selectPushAdmin',
      method: HttpMethod.POST,
      data: {},
      showLoading: false,
    })

    return result
  }

  /**
   * 푸시 설정 정보 저장
   *
   * @param {SetPushNotification} pushNotiSetting
   * @returns
   * @memberof PushService
   */
  async setPushAdmin(pushNotiSetting: SetPushNotification) {
    const result = await this.$ustra.api.call<ApiResponse<SetPushNotification>>({
      url: '/api/cm/push/mergePushAdmin',
      method: HttpMethod.POST,
      data: { ...pushNotiSetting },
      showLoading: false,
    })

    return result
  }
}

export const pushService = new PushService()
export default pushService
